// extracted by mini-css-extract-plugin
export default {"link":"article-heading_link__ovbAq"};